var map = {
	"./big1.png": 1503,
	"./big2.png": 4614,
	"./big3.png": 4062,
	"./big4.png": 2547,
	"./big5.png": 6800,
	"./big6.png": 5853,
	"./big7.png": 9596,
	"./big8.png": 3077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8874;